import styled from 'styled-components';
import { MDBDropdown, MDBDropdownItem } from 'mdbreact';
import { colors, MediaQuery } from '../../../theme/style-helpers';
import ChevronRightBlack from '../../../assets/icons/ChevronRightBlack.svg';
import ChevronRightOrange from '../../../assets/icons/ChevronRightOrange.svg';
import ChevronLeftBlack from '../../../assets/icons/ChevronLeftBlack.svg';
import ChevronLeftOrange from '../../../assets/icons/ChevronLeftOrange.svg';

export const FiltersAndTableContainer = styled.div`
  transform: rotateX(-180deg);
  display: grid;
`;

export const PaginationContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: center;
  grid-gap: 32px;
  margin-bottom: 40px;

  button:first-child, button:last-child {
    ${MediaQuery.xSmall`
      display: none;
    `}
  }
`;

export const PageNumber = styled.button`
  font-size: 16px 0px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  border: none;
  background-color: transparent;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  ${({ selected }) => selected && `
    font-weight: 700;
    border-bottom: 2px solid ${colors.BRAND_ORANGE};
  `};
`;

export const NoResults = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 85px;
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  transform: rotateX(180deg);
  padding-bottom: 16px;

  &::-webkit-scrollbar {
    width: 14px;
    height: ${({ scrollbarheight }) => (scrollbarheight ? `${scrollbarheight}` : 'auto')};
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px 1px ${colors.COOL_GREY};
    border-radius: 100px;
    border: 1px solid transparent;

    ${MediaQuery.medium`
      margin-left: 12px;
      margin-right: 12px;
    `}
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 10px ${colors.BRAND_ORANGE};
    border: 2px solid transparent;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-button:horizontal:decrement {
    background-image: url(${ChevronLeftOrange});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &:hover {
      background-image: url(${ChevronLeftBlack});
    }
  }

  &::-webkit-scrollbar-button:horizontal:increment {
    background-image: url(${ChevronRightOrange});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &:hover {
      background-image: url(${ChevronRightBlack});
    }
  }
`;

export const StyledTable = styled.table`
  margin-bottom: 16px;
  min-width: 100%;

  thead {
    background-color: ${colors.LIGHT_GREY};
    border-radius: 1px;

    th {
      background-color: ${colors.LIGHT_GREY};
    }
  }

  td, th {
    padding: 16px 16px;
    white-space: wrap;
  }

  tbody tr {
    border-bottom: 1px solid ${colors.COOL_GREY};

    td {
      background-color: ${colors.WHITE};
    }
  }

  th {
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    letter-spacing: 0em;
    cursor: pointer;

    img {
      margin-left: 8px;
    }
  }
`;

export const TableDataCell = styled.td`
  font-size: 14px;
  font-weight: 400;
  font-family: Montserrat;
  line-height: 21px;
  letter-spacing: 0em;
  vertical-align: ${({ topAligned }) => (topAligned ? 'top' : 'baseline')};
  text-align: ${({ textAlignCenter }) => (textAlignCenter ? 'center' : 'left')};
  colspan: ${({ colspan }) => colspan};

  span {
    font-weight: 600;
    line-height: 19px;
  }

  p {
      margin-bottom: 0px;
  }
`;

export const TableRow = styled.tr`
  tbody {
    background-color: gray;
    display: flex;
    flex-grow: 1;
  }
`;

export const ReversedIcon = styled.img`
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
`;

export const CellContainer = styled.div`
  display: grid;
  grid-gap: 4px;
`;

export const StatusContainer = styled.div`
  display: grid;
  grid-gap: 8px;
`;

export const StatusLine = styled.div`
  position: relative;
  width: 120px;
  height: 1px;
  border-radius: 100px;
  background-color: ${colors.COOL_GREY};

  &:before {
    content: '';
    position: absolute;
    width: ${({ bgWidth }) => bgWidth && bgWidth};
    height: 1px;
    background-color: ${({ bgColor }) => bgColor && bgColor};
  }
`;

export const ProgressBarSpacerContainer = styled.div`
  padding: 10px 0px;

  p {
    width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ProgressBarContainer = styled.div`
  height: 1px;
  width: 100%;
  position: relative;
  display: grid;
`;

const BaseBox = styled.div`
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 0px;
`;

export const ProgressBarBackground = styled(BaseBox)`
  background: grey;
  width: 100%;
`;

export const ProgressBar = styled(BaseBox)`
  background: ${(props) => ((props.color) ? props.color : colors.BRAND_ORANGE)};
  width: ${({ progress }) => progress || 0}%;
`;

export const DropdownItem = styled(MDBDropdownItem)`
  display: flex !important;
  align-items: center !important;
  padding: 0px !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  cursor: pointer;
  color: ${colors.BLACK};

  &:disabled {
    color: ${colors.DARK_GREY} !important;
  }

  &:hover {
    path {
      fill: ${colors.BRAND_ORANGE};
    }

    p {
      color: ${colors.BRAND_ORANGE};
    }
  }
`;

export const ExpandCellContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
`;

export const TableData = styled.td`
  colspan: ${(props) => props.colspan}
`;

export const TableHeader = styled.thead`
  display: block;
  width: 100%;
`;

export const TableBody = styled.tbody`
  display: block;
  width: 100%;
  max-height: 480px;
  overflow-y: auto;
  overflow-x: hidden;

  tr {
    cursor: ${(props) => ((props.isShipments) ? 'pointer' : 'auto')};
  }
`;

export const StyledMDBDropdown = styled(MDBDropdown)`
  .dropdown-menu {
    padding: 24px;
    background-color: ${colors.LIGHT_GREY} !important;
    cursor: default;

    >div {
      display: grid;
      grid-gap: 24px;
    }
  }

  justify-items: center;
`;

export const DropdownItemIcon = styled.div`
  width: 20px;
  height: 20px;
  background: url( ${({ iconSrc }) => iconSrc});
  background-repeat: no-repeat;
  background-size: auto 20px;
  margin: 0;
  margin-right: 8px;
`;

export const TableViewAllButtonWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ExpandableTrackingWrapper = styled.div`
  position: relative;
  min-height: 600px;
`;

export const DeliveryPhotoSection = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  row-gap: 16px;
  padding: 32px 0;
  border-top: 1px solid #D9D9D6;
  margin-top: 24px;
`;

export const DeliveryPhotoTitle = styled.h3`
  margin: 0;
  font-weight: 600;
  font-size: 18px;
  line-height: 150%;
  color: ${colors.BLACK};
`;

export const DeliveryPhotoInputRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const DeliveryPhotoPostalInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DeliveryPhotoPostalInput = styled.input`
  height: 48px;
  padding: 12px 16px;
  border: 1px solid ${({ hasError }) => (hasError ? colors.ERROR : colors.COOL_GREY)};
  border-radius: 1px;
  font-size: 16px;
  line-height: 150%;
  color: ${colors.BLACK};
  background-color: ${colors.WHITE};
  outline: none;
  width: 260px;
  box-sizing: border-box;

  &::placeholder {
    color: ${colors.DARK_GREY};
  }

  &:focus {
    border-color: ${({ hasError }) => (hasError ? colors.ERROR : colors.BLACK)};
    outline: none;
  }
`;

export const DeliveryPhotoError = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 130%;
  color: #D44333;
`;

export const DeliveryPhotoImg = styled.img`
  max-width: 100%;
  max-height: 480px;
  object-fit: contain;
  border: 1px solid #D9D9D6;
`;

export const DeliveryPhotoMessage = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 150%;
  color: ${colors.BLACK};
`;

export const MobileExpanderWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: #FFF;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 25px;

  svg {
    margin-right: 8px;
  }
`;

export const DropdownText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
`;
